<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>

<mat-dialog-actions >
  <button mat-button cdkFocusInitial mat-dialog-close>Ok</button>
</mat-dialog-actions>